/* Kōbu Press & Media — light scroll reveal. Safe to load more than once. */
(function () {
  if (window.__kobuPressReveal) return;
  window.__kobuPressReveal = true;

  function init() {
    var nodes = document.querySelectorAll('.kobu-press__reveal');
    if (!nodes.length) return;

    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) {
        n.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    nodes.forEach(function (n, i) {
      n.style.transitionDelay = Math.min(i % 6, 5) * 60 + 'ms';
      observer.observe(n);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();